import { Box } from '@mui/joy'
import { ReactNode, useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from '~/shared/ui/Modal'
import { Form, FormValues } from './Form'

type TerminateModalProps = {
  isShow: boolean
  onOk: (reasons: string[]) => Promise<void>
  onCancel: () => void
  extraBlock?: ReactNode
  buttonSuccessTitle?: string
}

export function TerminateModal({
  isShow,
  onOk,
  extraBlock,
  onCancel,
  buttonSuccessTitle,
}: TerminateModalProps) {
  const { t } = useTranslation()

  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)

  const handleSuccess = useCallback(
    async ({ reasons }: FormValues) => {
      try {
        setIsSubmitting(true)
        await onOk(reasons)
      } finally {
        setIsSubmitting(false)
      }
    },
    [onOk],
  )

  return (
    <Modal
      isShow={isShow}
      title={t('contract termination')}
      dialogProps={{
        sx: {
          minWidth: '600px',
          maxWidth: '600px',
        },
      }}
    >
      <Box sx={{ padding: '4px' }}>
        {extraBlock}
        <Form
          onSuccess={handleSuccess}
          onCancel={onCancel}
          isSubmitting={isSubmitting}
          buttonSuccessTitle={buttonSuccessTitle}
        />
      </Box>
    </Modal>
  )
}
